import React from 'react';

import type { IconProps } from '@atlaskit/icon/types';

import intentStartCreatingIconUrl from '../assets/intent-start-creating.svg';

export const IntentStartCreatingIcon = (_props: IconProps) => (
	<img
		src={intentStartCreatingIconUrl}
		alt=""
		width={24}
		height={24}
		role="presentation"
		aria-hidden="true"
	/>
);
